import { dsmOpsAxios } from '.';
import { PagedData, Response, TaskStatus } from '../types';
import {
  TaskGroupType,
  TaskGroupStatus,
  TaskTypeConfig,
  JInteger,
  JBinary,
  JSequence,
  JText,
} from '../types/Task';

export type GetTasksParams = {
  limit?: number;
  type?: TaskGroupType;
  nextCursor?: string;
  fromDate?: string;
  toDate?: string;
  projectId?: string;
};

export type GetConfigParams = {
  name: string;
  projectId: string;
  endpointIds: string[];
  taskType: TaskTypeConfig;
};

export type UpdatedConfigParams = {
  name: string;
  projectId: string;
  endpointIds: string[];
  taskType: TaskTypeConfig;
  payload: UpdateConfigPayload;
};

export type UpdateConfigPayload = {
  schemaVersion?: string;
  entries?: UpdateConfigEntriesType[];
  version?: string;
};

export type UpdateConfigEntriesType = {
  name: string;
  value: JInteger | JBinary | JSequence | JText;
};

export type Task = {
  endpointId: string;
  projectId: string;
  status: TaskStatus;
  payload?: {
    req: number;
    delay: number;
    repeats: number;
    audioTrackId: number;
    action?: {
      type?: string;
    };
  };
  result: {
    message: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type TaskGroup = {
  id: string;
  name: string;
  content: string;
  status: TaskGroupStatus;
  type: TaskGroupType;
  tasks: Array<Task>;
  createdAt: string;
  updatedAt: string;
};

export const getTasks = (params?: GetTasksParams) => {
  return dsmOpsAxios.get<PagedData<TaskGroup>>('/v1/tasks', {
    params,
  });
};

export const createTask = (params?: GetConfigParams) => {
  return dsmOpsAxios.post('/v1/tasks', {
    name: params?.name,
    projectId: params?.projectId,
    endpointIds: params?.endpointIds,
    task: {
      type: params?.taskType,
    },
  });
};

export const updateTask = (params: UpdatedConfigParams) => {
  return dsmOpsAxios.post('/v1/tasks', {
    name: params.name,
    projectId: params.projectId,
    endpointIds: params.endpointIds,
    task: {
      type: params.taskType,
      payload: params.payload,
    },
  });
};

export const updateFirmWareFile = ({
  version,
  file,
}: {
  version: string;
  file: File;
}) => {
  return dsmOpsAxios.post(
    `/v1/dasloop-protocol/firmware-files/${version}`,
    file,
  );
};

export const getDasloopProtocolSchemas = () => {
  return dsmOpsAxios.get<Response<Record<string, Record<string, string>[]>>>(
    `/v1/das-endpoints/dasloop-protocol-schemas`,
  );
};

type FirmwareVersionResponse = Response<
  [
    {
      firmwareVersion: string;
      files: Array<{
        id: string;
        name: string;
        hardwareVersion: string;
        firmwareGroupId: string;
      }>[];
    },
  ]
>;

export const getDasloopFirmwareVersion = () => {
  return dsmOpsAxios.get<FirmwareVersionResponse>(
    `/v1/dasloop-protocol/firmware-files`,
  );
};

export const getDassensesFirmwareVersion = () => {
  return dsmOpsAxios.get<FirmwareVersionResponse>(
    `/v1/dassenses-protocol/firmware-files`,
  );
};
